__turbopack_context__.v({
  "circle-image": "CircadianCard-module__pR88vq__circle-image",
  "root": "CircadianCard-module__pR88vq__root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
});
